import Tooltip from '@/components/lib/Tooltip/Tooltip';

export const Button: React.FC<{
  type: 'button' | 'submit' | 'reset' | undefined;
  children: React.ReactNode;
  className?: string;
  loading?: boolean;
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  style?: React.CSSProperties;
  loadingIndicatorStyle?: React.CSSProperties;
  showTooltip?: boolean;
  tooltipBody?: string;
  tooltipId?: string;
}> = (props) => {
  const button = <button
    type={props.type}
    className={props.className}
    disabled={props.loading || props.disabled}
    onClick={props.onClick}
    style={props.style}
  >
    {props.loading ? <Spinner style={props.loadingIndicatorStyle} /> : props.children}
  </button>
  if(props.showTooltip && props.tooltipBody && props.tooltipId) {
    return <Tooltip id={props.tooltipId} body={props.tooltipBody}>
      {button}
    </Tooltip>
  }
  return button;
};

function Spinner({ style }: { style?: React.CSSProperties }) {
  return (
    <svg height="18" style={style} viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient x1="8.042%" y1="0%" x2="65.682%" y2="23.865%" id="a">
          <stop stopColor="currentColor" stopOpacity="0" offset="0%" />
          <stop stopColor="currentColor" stopOpacity=".631" offset="63.146%" />
          <stop stopColor="currentColor" offset="100%" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <g transform="translate(1 1)">
          <path d="M36 18c0-9.94-8.06-18-18-18" id="Oval-2" stroke="url(#a)" strokeWidth="2">
            <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="0.9s" repeatCount="indefinite" />
          </path>
          <circle fill="currentColor" cx="36" cy="50" r="1">
            <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="0.9s" repeatCount="indefinite" />
          </circle>
        </g>
      </g>
    </svg>
  );
}
